export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDFq-bwSaQ4hs0LwZ8x9cF5giwJgmDxALE',
    authDomain: 'torreonmarket-25713.firebaseapp.com',
    databaseURL: 'https://torreonmarket-25713.firebaseio.com',
    projectId: 'torreonmarket-25713',
    storageBucket: 'torreonmarket-25713.appspot.com',
    messagingSenderId: '972615946393',
    appId: '1:972615946393:web:8ba065e61ba8a5eb816808',
    measurementId: 'G-YFVGTVBKWT'
  }
};
